import { combineReducers } from '@ngrx/store';

import { searchAllParams } from './state/search-all.reducer';
import { appStateSliceKey } from 'Angular/state/app-state/app-state.reducer';

import { SEARCH_ALL_PARAMS_APP_STATE_SLICE_KEY, SEARCH_ALL_PARAMS_SYSTEM_DEFAULT_STATE } from './state/constants';

import { createReducerWithAppState } from 'Angular/state/app-state/utils';

const initialSystemState = {
    [SEARCH_ALL_PARAMS_APP_STATE_SLICE_KEY]: SEARCH_ALL_PARAMS_SYSTEM_DEFAULT_STATE,
};

export const reducers = combineReducers({
    appStateSliceKey,
    searchAllParams,
});
export const rootReducer = createReducerWithAppState(reducers, initialSystemState, {});
